var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current_user.id)?_c('main-content',[(_vm.$can('change-settings', 'open-banking'))?_c('manage-settings'):_c('common-settings')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }